import React, { useCallback, useContext, useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from '../context/LanguagesContext'
import { getEntityFullName } from './components/tools'
import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
import { Roles } from '../hooks/auth.hook'
import { Gender } from '../constants';

import { Container, Dropdown, DropdownButton, ListGroup } from 'react-bootstrap'; // , Button, Form, Row, Col
import StatisticsBlock from "./statistics-data/StatisticsBlock";
import { OfficersBlock } from './statistics-data/OfficersBlock';
import desanitizeText from '../utils/desanitizeText';

// Toggle whether to display answer option texts or raw ids for single/multi answers
// false => show ids (current default); true => show localized texts
const SHOW_ANSWER_TEXTS = false;

export const DataPage = () => {
    const { token, role } = useContext(AuthContext)
    const { pageLanguage, activeLanguage } = useContext(LanguagesContext);
    const { request, loading, error } = useHttp()
    const [receivedError, setReceivedError] = useState(error)

    const [clients, setClients] = useState([])
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [statisticCollection, setStatisticCollection] = useState(null);
    const [time, setTime] = useState({ min_date: null, max_date: null })
    const [searchData, setSearchData] = useState({ age_search_min: 0, age_search_max: 80 })
    const [searchRequest, setSearchRequest] = useState({ type: 'all', name: 'All' })

    const [progressData, setProgressData] = useState([])  // officer->teams->lesson,users,progress
    const [extraContent, setExtraContent] = useState([])  // for parsed logs and quizzes




    const fetchTime = useCallback(async () => {

        try {
            const fetched = await request('/statistic/range', 'GET', null, {
                'x-access-token': token
            });

            if (fetched.min_date && fetched.max_date) {
                let time = { min_date: fetched.min_date, max_date: fetched.max_date }
                setTime(time)

                setStartDate(new Date(parseInt(fetched.min_date)))
                setEndDate(new Date(parseInt(fetched.max_date)))

            }
            console.log("fetched time:", fetched);
            fetchClients();

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    const fetchClients = useCallback(async () => {
        let path
        if (role === Roles.Admin) {
            path = '/client/all'
        } else {
            path = '/client/my'
        }
        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })
            console.log("clients:", fetched);
            if (fetched) {
                if (Array.isArray(fetched))
                    setClients(fetched)
                else {
                    setClients([fetched.client])
                    getClientStatistics()
                }
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, role])

    useEffect(() => {
        fetchTime()
    }, [fetchTime])

    useEffect(() => {
        if (progressData.length) {
            getLogsStatistics();
        }
    }, [progressData]);

    const getClientStatistics = async (clientId) => {
        getUsersProgress(clientId);
    }


    const getUsersProgress = async (clientId) => {
        try {
            const fetched = await request(`/statistic/teams${clientId ? `?clientId=${clientId}` : ''}`, 'GET', null, {
                'x-access-token': token
            })

            if (fetched?.officers) {
                setProgressData(fetched.officers);
            }

        } catch (e) {
            setReceivedError(e)
        }
    }


    // let searchDataTest = {platform:[]}
    const updateSearchData = (key, val) => {

        setSearchData(
            item => {
                item[key] = val
                return item
            }
        )
        //console.log('search upd:', key, val);
    }

    const getLogsStatistics = async () => { // main flow

        if (endDate && startDate) {
            if (Date.parse(endDate) < Date.parse(startDate)) {
                setReceivedError({ errors: [{ msg: 'Start date cant be after End date' }] });
                return;
            }

            //console.log('date is good: ' + startDate + " / " + endDate);
            let stats = await request(`/statistic`, 'POST', {
                ...searchRequest,
                startDate: Date.parse(startDate),
                endDate: Date.parse(new Date(endDate.setHours(23, 59, 59, 999)))
            }, {
                'x-access-token': token
            })

            if (stats?.data) {
                setStatisticCollection(stats.data);
                checkSearchParams(stats);
                countStatistic(stats.data);
            } else {
                setReceivedError({ errors: [{ msg: 'Date not set or set wrong' }, startDate, endDate] });
                return;
            }
        }
    }

    const checkSearchParams = (stats) => {

        if (stats !== null) {
            if (stats.platform && stats.platform.length) {
                //console.log('PLATFORM UPDATE TRIGGER');
                updateSearchData('platform', stats.platform)
                updateSearchData('platform_search', 'All')
            }
            // updateSearchData('gender_search', 'All')
            // updateSearchData('gender_search_title', 'All')
            // updateSearchData('age_search', 'All')

            //console.log('searchData:', searchData);
        }
    }

    const countStatistic = (logs) => {

        console.log('statistic counter for ', searchRequest, logs);

        const teams = progressData.flatMap(officer => officer.teams);
        let clientsData = clients
            .filter(g => searchRequest.type === 'all' || g.id === searchRequest.id)
            .map(client => {

                let result = {
                    name: "",
                    progress: { started: 0, finished: 0 },
                    gender: { male: 0, female: 0, other: 0, unknown: 0 },
                    logs: [],
                    teams: [],
                };
                result.name = client.name;
                result.id = client.id;

                //todo: set teams aggregation
                let currentClientLogs = logs.reduce((acc, log) => {
                    const team = teams.find(
                        team => team.client_id === client.id &&
                            team.users.some(user => user.id === log.user_id) &&
                            team.lessons.some(
                                lesson => lesson.id === log.params.lessonId && lesson.experiences.some(exp => exp.id === log.params.experienceId)
                            ),
                    );

                    // include all platforms including WindowsEditor
                    if (team) {
                        acc.push({ ...log, team });
                    }

                    return acc;
                }, []);

                // console.log("checking exp:", client.id, progress);
                let experience_started = currentClientLogs.filter(log => {
                    if (log.event === 'ExperienceStart') {
                        const user = log.team.users.find(user => user.id === log.user_id);

                        switch (user.gender) {
                            case Gender.Female:
                                result.gender.female++;
                                break;
                            case Gender.Male:
                                result.gender.male++;
                                break;
                            case Gender.NotBinary:
                                result.gender.other++;
                                break;
                            default:
                                result.gender.unknown++;
                                break;
                        }

                        return true;
                    }
                    else
                        return false;
                }).length;

                let experience_finished = currentClientLogs.filter(log =>
                    log.event === 'ExperienceEnd'
                ).length;

                result.progress = {
                    started: result.progress.started + experience_started,
                    finished: result.progress.finished + experience_finished
                };

                currentClientLogs.forEach(log => {
                    if (log.event === "QuizAnswer") {
                        const user = log.team.users.find(user => user.id === log.user_id);
                        const teamLesson = log.team.lessons.find(lesson => lesson.id === log.params.lessonId);
                        const teamExperience = teamLesson.experiences.find(exp => exp.id === log.params.experienceId);
                        const quiz = teamExperience?.quiz?.find(quiz => quiz.id === log.params.quizId);

                        if (!quiz) {
                            console.log("[WARN] Quiz not found:", {
                                logId: log.id,
                                userId: log.user_id,
                                lessonId: log.params.lessonId,
                                experienceId: log.params.experienceId,
                                quizId: log.params.quizId,
                                teamLesson: teamLesson,
                                teamExperience: teamExperience
                            });
                            return;
                        }

                        let teamName = log.team[`name_${pageLanguage}`] || getEntityFullName(log.team, activeLanguage);
                        let lessonName = teamLesson?.[`name_${pageLanguage}`] || (teamLesson ? getEntityFullName(teamLesson, activeLanguage) : undefined);
                        let experienceName = teamExperience?.[`name_${pageLanguage}`] || (teamExperience ? getEntityFullName(teamExperience, activeLanguage) : undefined);

                        if (!log.team[`name_${pageLanguage}`]) console.log('[DataPage] Fallback team name used', { teamId: log.team.id, teamName });
                        if (teamLesson && !teamLesson[`name_${pageLanguage}`]) console.log('[DataPage] Fallback lesson name used', { lessonId: teamLesson.id, lessonName });
                        if (teamExperience && !teamExperience[`name_${pageLanguage}`]) console.log('[DataPage] Fallback experience name used', { experienceId: teamExperience.id, experienceName });

                        // Resolve localized text preferences based on experience language
                        const experienceLang = teamExperience && teamExperience.language ? teamExperience.language : null;
                        const resolveLocalized = (obj, baseKeys) => {
                            if (!obj) return undefined;
                            if (experienceLang) {
                                for (const k of baseKeys) {
                                    const langKey = `${k}_${experienceLang}`;
                                    if (obj[langKey] != null && obj[langKey] !== '') return obj[langKey];
                                }
                            }
                            for (const k of baseKeys) {
                                if (obj[k] != null && obj[k] !== '') return obj[k];
                            }
                            return undefined;
                        };

                        const safeDecodeURIComponent = (text) => {
                            if (text == null) return text;
                            try {
                                return decodeURIComponent(text);
                            } catch (e) {
                                return text;
                            }
                        };

                        // Helper: resolve answer option text by id across possible quiz structures
                        const findOptionTextById = (quizObj, answerObj) => {
                            if (!quizObj || !answerObj) return undefined;
                            const answerId = answerObj.answerId;
                            const questionId = answerObj.questionId || answerObj.qid || answerObj.question_id;
                            const idsEqual = (a, b) => {
                                // loose compare to tolerate string/number mismatches
                                // eslint-disable-next-line eqeqeq
                                return a == b;
                            };
                            if (!quizObj) return undefined;
                            // direct answers array
                            if (Array.isArray(quizObj.answers)) {
                                const m = quizObj.answers.find(opt => opt && idsEqual(opt.id, answerId));
                                if (m) return resolveLocalized(m, ['text', 'name', 'caption', 'title', 'value', 'label']);
                            }
                            // nested questions[].answers
                            if (Array.isArray(quizObj.questions)) {
                                // Prefer matching question by id if present in answer
                                const questionCandidates = questionId
                                    ? quizObj.questions.filter(q => idsEqual(q.id, questionId))
                                    : quizObj.questions;
                                for (const q of questionCandidates) {
                                    const containers = [q.answers, q.options, q.variants, q.choices];
                                    for (const c of containers) {
                                        if (Array.isArray(c)) {
                                            const m = c.find(opt => opt && idsEqual(opt.id, answerId));
                                            if (m) return resolveLocalized(m, ['text', 'name', 'caption', 'title', 'value', 'label']);
                                        }
                                    }
                                }
                            }
                            // other possible containers
                            if (Array.isArray(quizObj.options)) {
                                const m = quizObj.options.find(opt => opt && idsEqual(opt.id, answerId));
                                if (m) return resolveLocalized(m, ['text', 'name', 'caption', 'title', 'value', 'label']);
                            }
                            return undefined;
                        };

                        // Map answers to display value: handle id(s) and free-text
                        const renderedAnswers = (log.params.answers || []).map(a => {
                            if (a && a.answerId !== undefined) {
                                // Multi-select: array of ids
                                if (Array.isArray(a.answerId)) {
                                    if (!SHOW_ANSWER_TEXTS) {
                                        return a.answerId.map(id => String(id)).join(' | ');
                                    } else {
                                        const parts = a.answerId.map(id => {
                                            const textCandidate = findOptionTextById(quiz, { ...a, answerId: id });
                                            const decoded = safeDecodeURIComponent(textCandidate != null ? textCandidate : String(id));
                                            return desanitizeText(decoded);
                                        });
                                        return parts.join(' | ');
                                    }
                                }
                                // Single-select: single id
                                if (!SHOW_ANSWER_TEXTS) {
                                    return String(a.answerId);
                                } else {
                                    const textCandidate = findOptionTextById(quiz, a);
                                    const decoded = safeDecodeURIComponent(textCandidate != null ? textCandidate : String(a.answerId));
                                    return desanitizeText(decoded);
                                }
                            }
                            if (a && a.answerText !== undefined) {
                                return desanitizeText(a.answerText);
                            }
                            return '';
                        });

                        let line = {
                            date: new Date(parseInt(log.time, 10)).toISOString(),
                            email: user.email + (log.user_temp_pass_id ? ` (Team user - ${log.user_temp_pass_id})` : ''),
                            teamId: log.team.id,
                            teamName: teamName,
                            platform: log.platform,
                            gender: genderToLabel(log.gender),
                            age: log.age,
                            lessonName: lessonName,
                            experienceId: log.params.experienceId,
                            experienceName: experienceName,
                            quizId: log.params.quizId,
                            quizName: resolveLocalized(quiz, ['name']) || quiz.name,
                            answers: renderedAnswers
                        };
                        result.logs.push(line);

                    }
                });

                return result;
            });


        setExtraContent(clientsData)
        console.log("clientsData to show:", clientsData)
    };

    let genderToLabel = (id) => {
        switch (id) {
            case Gender.Male: return "male";
            case Gender.Female: return "female";
            case Gender.NotBinary: return "not binary";
            default:
                return "unknown";
        }
    };

    const onShowStatisticClick = () => {
        getClientStatistics(clients.find(item => item.id === searchRequest.id)?.id);
    };

    const setQuickDateRange = (range) => {
        const today = new Date();
        const maxDate = new Date(parseInt(time.max_date));
        const minDate = new Date(parseInt(time.min_date));
        
        let startDate, endDate;
        
        switch (range) {
            case 'today':
                startDate = new Date(today);
                endDate = new Date(today);
                break;
            case '2days':
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 1);
                endDate = new Date(today);
                break;
            case '7days':
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 6);
                endDate = new Date(today);
                break;
            case '2weeks':
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 13);
                endDate = new Date(today);
                break;
            case '30days':
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 29);
                endDate = new Date(today);
                break;
            case '60days':
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 59);
                endDate = new Date(today);
                break;
            default:
                return;
        }
        
        // Ensure dates are within the available range
        if (startDate < minDate) {
            startDate = new Date(minDate);
        }
        if (endDate > maxDate) {
            endDate = new Date(maxDate);
        }
        if (startDate > endDate) {
            startDate = new Date(endDate);
        }
        
        console.log(`Setting quick date range: ${range}`, { startDate, endDate });
        setStartDate(startDate);
        setEndDate(endDate);
    };


    return (
        <Container>
            {(receivedError) && console.log(receivedError) ?
                <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader />}

            <h3 className="FormTitle">Data</h3>
            {
                time.min_date && time.max_date &&
                <div>
                    <div className="d-flex FormText ">
                        <div>
                            From: <DatePicker
                                selected={startDate}
                                onChange={date => setStartDate(date)}
                                minDate={new Date(parseInt(time.min_date))}
                                maxDate={new Date(parseInt(time.max_date))}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                placeholderText="Select Start Date"
                                className="d-flex rounded border-white"
                                style={{ position: 'auto' }}
                                closeOnScroll={true}
                            />
                        </div>
                        <div className="mx-2 ">
                            To: <DatePicker
                                selected={endDate}
                                onChange={date => setEndDate(date)}
                                minDate={new Date(parseInt(time.min_date))}
                                maxDate={new Date(parseInt(time.max_date))}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                placeholderText="Select End Date"
                                className="d-inline rounded border-white"
                                fixedHeight
                                closeOnScroll={true}
                            />

                        </div>
                    </div>
                    
                    {/* Quick Date Range Buttons */}
                    <div className="my-3">
                        <div className="d-flex flex-wrap">
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('today')}
                            >
                                1 Day
                            </button>
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('2days')}
                            >
                                2 Days
                            </button>
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('7days')}
                            >
                                7 Days
                            </button>
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('2weeks')}
                            >
                                2 Weeks
                            </button>
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('30days')}
                            >
                                30 Days
                            </button>
                            <button 
                                className="btn btn-outline-light btn-sm mb-2"
                                style={{ marginRight: '12px' }}
                                onClick={() => setQuickDateRange('60days')}
                            >
                                60 Days
                            </button>
                        </div>
                    </div>
                    
                    <div className="my-4">

                        {role === 'admin'
                            &&
                            <DropdownButton
                                id="dropdown-basic-button"
                                variant="info"
                                title={searchRequest.id ? searchRequest.name : 'Select Users'}
                                className="d-inline mx-1 ">
                                <Dropdown.Item
                                    onClick={() => setSearchRequest({ type: 'all', name: 'All' })}>Select Client</Dropdown.Item>

                                {(clients && clients.length)
                                    ?
                                    clients.map((item, index) =>

                                        <Dropdown.Item
                                            onClick={() => setSearchRequest({ type: 'company', name: item.name, id: item.id })}
                                            key={index}>
                                            <span className="FormTextDark">{item.name}</span>
                                        </Dropdown.Item>
                                    )
                                    : ''}

                            </DropdownButton>
                        }
                        <button id="dropdown-basic-button" onClick={onShowStatisticClick}
                            className="ElementButton d-inline mx-2"
                            disabled={!searchRequest.id}>
                            Show
                        </button>

                    </div>

                </div>
            }


            {(searchData.filtered && searchData.filtered === 1)
                ?
                <span>Filters Applied for Minimum age {searchData.age_search_min}, Maximum age {searchData.age_search_max}, Gender: {searchData.gender_search_title}, Platform {searchData.platform_search}</span>
                : ''
            }
            {(searchRequest && extraContent && statisticCollection)
                ?
                <ListGroup className="my-2">
                    {extraContent.length ?

                        extraContent.map((clientData, index) => {
                            const officers = progressData.filter(officer => officer.client_id === clientData.id);
                            // Add safety check to ensure officers have teams property
                            const safeOfficers = officers.map(officer => ({
                                ...officer,
                                teams: officer.teams || []
                            }));

                            return (
                                <React.Fragment key={clientData.id}>
                                    <div className="mb-2">
                                        <OfficersBlock officers={safeOfficers} answers={clientData} />
                                    </div>
                                    <StatisticsBlock data={clientData} />
                                </React.Fragment>
                            );
                        }
                        )

                        : <span className="my-2 NoElementsText">No data</span>}
                </ListGroup>
                : <div className="d-block mx-auto my-1">
                    <span className="my-2 NoElementsText">No Statistic</span>
                </div>
            }

        </Container>
    )
}
